export default function isEmpty(value: string | number | null | undefined): boolean {
  if (typeof value === 'number') return false;

  return !value;
}
